import { createFileRoute } from '@tanstack/react-router';
import { ScrollytellingDemo } from '@/components/scrollytelling/scrollytelling-demo';

export const Route = createFileRoute('/example')({
  component: ExampleComponent,
});

function ExampleComponent() {
  return (
    <div className="w-full min-h-screen bg-gray-900">
      <ScrollytellingDemo />
    </div>
  );
}
